<template>
  <div>
    <div @click="launchFilePicker()">
      <slot name="activator"></slot>
    </div>
    <input
      type="file"
      style="display: none"
      ref="file"
      accept="audio/*"
      @change="onFileChange"
    >
    <v-dialog v-model="errorDialog" max-width="300">
      <v-card>
        <v-card-text class="subheading">{{errorText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="errorDialog = false" flat>Got it!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  export default {
    name: 'audioUploader',
    data: () => ({
      errorDialog: null,
      errorText: ''
    }),
    props: {
      value: Object
    },
    methods: {
      launchFilePicker () {
        this.$refs.file.click()
      },
      onFileChange (e) {
        const file = e.target.files
        const {maxSize} = this
        // check if user actually selected a file
        if (file.length > 0) {
          const audioFile = file[0]
          const fieldName = audioFile.name
          let size = audioFile.size / maxSize / maxSize
          if (!audioFile.type.match('audio.*')) {
            // check whether the upload is an audio
            this.errorDialog = true
            this.errorText = 'Please choose an audio file'
          } else if (size > 5) {
            // check whether the size is greater than the size limit
            this.errorDialog = true
            this.errorText = 'Your file is too big! Please select an audio under 1MB'
          } else {
            // Append file into FormData & turn file into audio URL
            // let formData = new FormData()
            let audioURL = URL.createObjectURL(audioFile)
            // formData.append(fieldName, audioFile)
            // // Emit FormData & audio URL to the parent component
            this.$emit('input', {audioName: fieldName, audioFile, audioURL})
          }
        }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/uploader/audioUploader.vue